import script from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryFinances.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryFinances.vue?vue&type=style&index=0&id=e0589c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0589c16"]])

export default __exports__